import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useConfig(kind) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api
      .get(`/config/${kind}`)
      .then(({ data }) => setItems(data))
      .catch(() => setItems([]));
  }, [kind]);
  return items;
}
